import request from '@/utils/request'
import { v2Host } from '@/config/host'

/**
 * 应用分类管理接口
 * http://playable.dev.com:8067/?doc=system/app_category.go
 * @param {page: int, page_size: int, platform: {ios/android}} params
 */
export function fetchAppCategoryList(params) {
  return request({
    url: `${v2Host}/system/app_category/customs`,
    method: 'get',
    params: params
  })
}
